<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Short Number</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" :disabled="numUsed" @click="editOperation"
            >Save</el-button
          >
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation('edit')"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation('edit')"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <recent-audits service="Short Number" :record="selectedShortNumber" />
      <div class="inline-form-group">
        <el-col :span="11">
          <el-input v-model="number" placeholder="Enter number">
            <template slot="prefix">
              <span>Number</span>
            </template>
            <template slot="append" v-if="numUsed">
              <in-use :inUse="numInUse" />
            </template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="12">
          <el-input
            placeholder="Enter destination number"
            v-model="editForm.destnumber"
          >
            <template slot="prefix">
              Destination number
            </template>
          </el-input>
        </el-col>
      </div>

      <el-input placeholder="Enter description" v-model="editForm.description">
        <template slot="prefix">Description</template>
      </el-input>
    </el-form>
  </el-dialog>
</template>

<script>
import RecentAudits from "@/components/RecentAudits";
import InUse from "@/components/InUse";

export default {
  name: "ShortNumbersEditForm",

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    selectedShortNumber: { required: true },
    numInUse: { required: true },
    editProcessing: { required: true }
  },

  components: { RecentAudits, InUse },

  data() {
    return {
      number: "",
      userChangedNumber: false,
      editForm: {
        number: "",
        destnumber: "",
        description: ""
      }
    };
  },

  computed: {
    numUsed() {
      return this.numInUse && this.numInUse.inUse;
    }
  },

  watch: {
    selectedShortNumber(val) {
      if (val) {
        const { number, destnumber, description } = val;
        this.number = number;
        this.initialNumber = number;
        this.editForm.destnumber = destnumber;
        this.editForm.description = description;
      }
    },

    number(val) {
      if (val) {
        this.editForm.number = val;

        if (!this.userChangedNumber) {
          this.userChangedNumber = true;
          return;
        }

        if (this.initialNumber === val) {
          this.$emit("checkForAvailableNum", "************");
          return;
        }

        this.$emit("checkForAvailableNum", val);
      } else {
        this.$emit("checkForAvailableNum", "************");
      }
    },

    clearFormFields(val) {
      if (val) {
        this.clearFields();
      }
    }
  },

  methods: {
    editOperation() {
      const editBody = { ...this.editForm };
      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.number = "";
      this.initialNumber = "";
      this.editForm = {
        number: "",
        destnumber: "",
        description: ""
      };
    }
  }
};
</script>
